import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import BookingPage from "./pages/BookingPage";
import BookPrototypePage from "./pages/BookPrototypePage";
import ServicesMenu from "./pages/ServicesMenu";
import QRCodePage from "./pages/QRCodePage";
import AboutPage from "./pages/AboutPage";
import BlogListing from "./pages/BlogListing";
import BlogPost from "./pages/BlogPost";
import BlogPostDowntown from "./pages/BlogPostDowntown";
import BlogPostHealingMidtown from "./pages/BlogPostHealingMidtown";
import BlogPostMidtownMassage from "./pages/BlogPostMidtownMassage";
import BlogPostDeepTissueVsSwedish from "./pages/BlogPostDeepTissueVsSwedish";
import BlogPostCertifiedMidtown from "./pages/BlogPostCertifiedMidtown";
import BlogPostBestTimeOfYear from "./pages/BlogPostBestTimeOfYear";
import BlogPostCurtisPark from "./pages/BlogPostCurtisPark";
import BlogPostLandPark from "./pages/BlogPostLandPark";
import BlogPostEastSacramento from "./pages/BlogPostEastSacramento";
import BlogPostOakParkPain from "./pages/BlogPostOakParkPain";
import BlogPostPocketPain from "./pages/BlogPostPocketPain";
import BlogPostArdenArcadePain from "./pages/BlogPostArdenArcadePain";
import BlogPostCarmichaelPain from "./pages/BlogPostCarmichaelPain";
import BlogPostElmhurstPain from "./pages/BlogPostElmhurstPain";
import BlogPostSwedishMidtown from "./pages/BlogPostSwedishMidtown";
import BlogPostWhatsSwedishLike from "./pages/BlogPostWhatsSwedishLike";
import BlogPostIsDeepTissueSupposedToHurt from "./pages/BlogPostIsDeepTissueSupposedToHurt";
import BlogPostHowDoIKnow from "./pages/BlogPostHowDoIKnow";
import BlogPostWhatToWear from "./pages/BlogPostWhatToWear";
import BlogPostHowOften from "./pages/BlogPostHowOften";
import BlogPostSwedishSacGuide from "./pages/BlogPostSwedishSacGuide";
import BlogPostShouldITip from "./pages/BlogPostShouldITip";
import BlogPostPregnancyMassage from "./pages/BlogPostPregnancyMassage";
import BlogPostCertifiedSwedishMidtown from "./pages/BlogPostCertifiedSwedishMidtown";
import MidtownStudioPage from "./pages/MidtownStudioPage";
import RouteSeo from "./components/RouteSeo";
import GiftCertificatesPage from "./pages/GiftCertificatesPage";
import GiftCertificatePreviewPage from "./pages/GiftCertificatePreviewPage";
import FAQPage from "./pages/FAQPage";
import StickyMobileBookBar from "./components/StickyMobileBookBar";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteSeo />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/book-prototype" element={<BookPrototypePage />} />
          <Route path="/services-menu" element={<ServicesMenu />} />
          <Route path="/qr-code" element={<QRCodePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/massage-therapy-sacramento" element={<BlogPost />} />
          <Route path="/blog/downtown-sacramento-massage-therapist" element={<BlogPostDowntown />} />
          <Route path="/blog/healing-massage-therapy-midtown-sacramento" element={<BlogPostHealingMidtown />} />
          <Route path="/blog/massage-therapy-midtown-sacramento" element={<BlogPostMidtownMassage />} />
          <Route path="/blog/deep-tissue-vs-swedish-massage-midtown-sacramento" element={<BlogPostDeepTissueVsSwedish />} />
          <Route path="/blog/certified-massage-therapist-midtown-sacramento" element={<BlogPostCertifiedMidtown />} />
          <Route path="/blog/best-time-of-year-to-start-regular-massage-therapy" element={<BlogPostBestTimeOfYear />} />
          <Route path="/blog/curtis-park-massage-therapist" element={<BlogPostCurtisPark />} />
          <Route path="/blog/land-park-massage-therapist" element={<BlogPostLandPark />} />
          <Route path="/blog/east-sacramento-massage-therapist" element={<BlogPostEastSacramento />} />
          <Route path="/blog/back-and-neck-pain-massage-oak-park" element={<BlogPostOakParkPain />} />
          <Route path="/blog/back-and-neck-pain-massage-the-pocket" element={<BlogPostPocketPain />} />
          <Route path="/blog/back-and-neck-pain-massage-arden-arcade" element={<BlogPostArdenArcadePain />} />
          <Route path="/blog/back-and-neck-pain-massage-carmichael" element={<BlogPostCarmichaelPain />} />
          <Route path="/blog/back-and-neck-pain-massage-elmhurst" element={<BlogPostElmhurstPain />} />
          <Route path="/blog/swedish-massage-midtown-sacramento-ca" element={<BlogPostSwedishMidtown />} />
          <Route path="/blog/whats-swedish-massage-in-sacramento-like" element={<BlogPostWhatsSwedishLike />} />
          <Route path="/blog/is-deep-tissue-massage-supposed-to-hurt" element={<BlogPostIsDeepTissueSupposedToHurt />} />
          <Route path="/blog/how-do-i-know-if-i-need-a-massage" element={<BlogPostHowDoIKnow />} />
          <Route path="/blog/what-should-i-wear-to-my-first-massage" element={<BlogPostWhatToWear />} />
          <Route path="/blog/how-often-should-i-get-a-massage" element={<BlogPostHowOften />} />
          <Route path="/blog/swedish-massage-sacramento-ca-midtown-downtown" element={<BlogPostSwedishSacGuide />} />
          <Route path="/blog/should-i-tip-my-massage-therapist" element={<BlogPostShouldITip />} />
          <Route path="/blog/can-i-get-a-massage-while-pregnant" element={<BlogPostPregnancyMassage />} />
          <Route path="/blog/certified-swedish-massage-midtown-sacramento" element={<BlogPostCertifiedSwedishMidtown />} />
          <Route path="/massage-midtown-sacramento" element={<MidtownStudioPage />} />
          <Route path="/gift-certificates" element={<GiftCertificatesPage />} />
          <Route path="/gift-certificate-preview" element={<GiftCertificatePreviewPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
        <StickyMobileBookBar />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
